export default "__VITE_ASSET__20b5733a__"